import '../../base/style/index.mjs';
import 'element-plus/theme-chalk/src/option-group.scss';
//# sourceMappingURL=index.mjs.map
